import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { useStore } from "../../../providers/AppProvider";
import { useFieldStore } from '../../fields/providers/FieldProvider';

type LayerSettingsProps = {
    onCancel: () => void,
    colorScaleRange: string,
    setColorScaleRange: Function,
}

const LayerSettings = ({ onCancel, colorScaleRange, setColorScaleRange}: LayerSettingsProps) => {
    const { filters, updateFilter } = useFieldStore();

    const onChange = (e: any) => {
        setColorScaleRange(e.target.value);
    };

    const cancelForm = () => {
        onCancel();
    };

    return (
        <div className="mb-2 card">
            <div className="p-2 card-body">
                <h5 className="text-base">Color Scale Range</h5>
                <div className="d-flex mt-2">
                    <Form.Control
                        as="select"
                        size="sm"
                        name="clipType"
                        value={colorScaleRange}
                        onChange={onChange}
                    >
                        <option value="field">Field</option>
                        <option value="global">Global</option>
                    </Form.Control>
                    <Button variant="secondary" className="" size="sm" onClick={cancelForm}>
                        Close
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default LayerSettings;
